// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_50-0";